import React, { useEffect } from "react";
import { WHY_PILLARS, PROCESS_STEPS } from "../data/site";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function AboutPage() {
  useEffect(() => {
    document.title = "About — Weldmatix Fusion";
  }, []);

  return (
    <div data-testid="page-about" className="bg-[#FFFFFF] pt-32 md:pt-40">
      <section className="max-w-7xl mx-auto px-6 lg:px-12 pb-16">
        <div className="eyebrow mb-4">// About Us</div>
        <h1 className="font-display uppercase tracking-tight text-slate-900 text-5xl md:text-7xl leading-[0.95] max-w-5xl">
          An engineering-driven<br /><span className="text-[#0EA5E9]">OEM</span> for the world's<br />critical industries.
        </h1>
        <p className="mt-8 max-w-3xl text-base md:text-lg text-[#475569] leading-relaxed">
          At Weldmatix, we engineer solutions that transform the world of weld overlay
          and advanced welding automation. Backed by decades of hands-on experience,
          our team blends deep industry expertise with cutting-edge technology to deliver
          high-performance welding systems that meet the evolving needs of the oil & gas,
          valve, waste-to-energy, and corrosion-resistant alloy (CRA) industries.
        </p>
        <p className="mt-6 max-w-3xl text-base md:text-lg text-[#475569] leading-relaxed">
          Born from the vision of being not just an equipment supplier, but a long-term
          solutions partner, Weldmatix is committed to engineering excellence, in-house
          manufacturing capability, and global responsive support.
        </p>
      </section>

      <section className="border-t border-[#E2E8F0]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
          <div className="eyebrow mb-6">// Core Values</div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
            {WHY_PILLARS.map((p) => (
              <div key={p.n} className="bg-[#FFFFFF] p-8 spec-card">
                <div className="font-mono-wm text-2xl text-[#0EA5E9]">{p.n}</div>
                <h3 className="mt-6 font-display uppercase text-slate-900 text-xl tracking-tight leading-tight">{p.t}</h3>
                <p className="mt-3 text-sm text-[#475569] leading-relaxed">{p.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="border-t border-[#E2E8F0]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
          <div className="eyebrow mb-6">// Capability</div>
          <h2 className="font-display uppercase text-slate-900 text-3xl md:text-5xl tracking-tight leading-[0.95] max-w-3xl">
            End-to-end OEM execution.
          </h2>
          <div className="mt-10 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
            {PROCESS_STEPS.map((s) => (
              <div key={s.n} className="bg-[#FFFFFF] p-6 spec-card">
                <div className="font-mono-wm text-3xl text-[#0EA5E9] font-bold">{s.n}</div>
                <h3 className="mt-6 font-display uppercase text-slate-900 text-base tracking-tight leading-tight">{s.t}</h3>
                <p className="mt-2 text-xs text-[#475569]">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="border-t border-[#E2E8F0]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <h3 className="font-display uppercase text-slate-900 text-3xl md:text-5xl tracking-tight leading-[0.95] max-w-2xl">
            Have a critical project?<br /><span className="text-[#0EA5E9]">Let's talk.</span>
          </h3>
          <Link to="/contact" data-testid="about-cta-contact" className="group inline-flex items-center gap-4 bg-[#0EA5E9] hover:bg-[#0284C7] text-white px-6 py-4 text-sm uppercase tracking-[0.2em]">
            Request Consultation <ArrowUpRight className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition" />
          </Link>
        </div>
      </section>
    </div>
  );
}
